import React from "react";
import { createSvgIcon } from "@material-ui/core";

const TrailerOutlineIcon = () => (
  <svg x="0" y="0" viewBox="0 0 512 512">
    <g>
      <g>
        <path
          d="M512,121H0v188.333h60V361H30v30h60v-81.667h30V361h154.58c6.192,17.458,22.865,30,42.42,30
			c11.517,0,22.032-4.354,30-11.495c7.968,7.142,18.483,11.495,30,11.495c11.517,0,22.032-4.354,30-11.495
			c7.968,7.142,18.483,11.495,30,11.495c24.813,0,45-20.187,45-45c0-15.114-7.498-28.502-18.961-36.667H512V121z M272,331H150
			v-21.667h122V331z M317,361c-8.271,0-15-6.729-15-15s6.729-15,15-15s15,6.729,15,15S325.271,361,317,361z M377,361
			c-8.271,0-15-6.729-15-15s6.729-15,15-15s15,6.729,15,15S385.271,361,377,361z M437,361c-8.271,0-15-6.729-15-15s6.729-15,15-15
			s15,6.729,15,15S445.271,361,437,361z M482,279.333H30V151h452V279.333z"
        />
      </g>
    </g>
  </svg>
);

export default createSvgIcon(<TrailerOutlineIcon />, "TrailerOutline");
